import { Checkbox, ListItemText, MenuItem, SelectProps, TextField } from "@mui/material";
import SelectFilterChip from "./Subcomponents/SelectFilterChip";
import createSlug from "../../Utilities/createSlug";

interface FilterMenuProps {
  id: string;
  htmlId?: string;
  name: string;
  label: React.ReactNode;
  selectedFilters: string[];
  availableFilters: string[];
  handleFilterChange: (event: any) => void;
  value: string[] | string;
  multiple: boolean;
  isLoading: boolean;
}

type FilterSelectProps = Partial<SelectProps> & {
  "data-test"?: string;
};

export function FilterMenu({
  id,
  htmlId,
  label,
  name,
  selectedFilters,
  handleFilterChange,
  availableFilters,
  value,
  multiple,
  isLoading,
}: FilterMenuProps) {
  const hasFiltersAvailable = availableFilters.length > 0;
  const buttonId = `filter-button-${id}`;
  const labelId = `${buttonId}${htmlId ? `-${htmlId}` : ""}-label`;
  return (
    <>
      <TextField
        data-test={"filter-menu-" + id}
        fullWidth
        select
        label={name}
        InputLabelProps={{
          id: labelId,
          "aria-label": `Filter by ${name}`,
        }}
        SelectProps={
          {
            "data-test": buttonId,
            disabled: !hasFiltersAvailable || isLoading,
            labelId,
            id,
            label,
            value: value ?? "",
            onChange: handleFilterChange,
            multiple,
            renderValue: (selected: any) => {
              return multiple ? <SelectFilterChip id={id} values={selected as string[]} /> : selected;
            },
            SelectDisplayProps: {
              "aria-labelledby": labelId,
            },
          } as FilterSelectProps
        }
      >
        {availableFilters.map((item, idx) => {
          const escapedItem = createSlug(item);
          return (
            <MenuItem
              key={id + idx}
              value={item}
              data-test={`filter-menu-${id}-${escapedItem}`}
              onClick={handleFilterChange}
              sx={(theme) => ({
                backgroundColor: selectedFilters.includes(item) ? theme.colors.primary.fade : "white",
                "&:hover": {
                  backgroundColor: "primary.light",
                  color: "primary.contrastText",
                },
              })}
            >
              {multiple ? (
                <>
                  <Checkbox checked={value.indexOf(item) > -1} />
                  <ListItemText primary={item} />
                </>
              ) : (
                item
              )}
            </MenuItem>
          );
        })}
      </TextField>
    </>
  );
}
